import {
  CellClassParams,
  Column,
  ColumnGroup,
  GridApi,
  IClientSideRowModel,
} from "@ag-grid-community/core";
import {
  ColDef,
  ColGroupDef,
} from "@ag-grid-community/core/dist/types/src/entities/colDef";
import { first, get, last } from "lodash-es";
import { flattenColDefs } from "shared/components/table/maybern/MaybernTableUtils";

export const getAgGridPrimaryHeaderRowCount = (api: GridApi | undefined) => {
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  const primaryHeaderRowCount = get(
    api,
    "columnModel.primaryHeaderRowCount",
  ) as number | undefined;
  return primaryHeaderRowCount || 0;
};

export const getAgColumnParents = (agColumn: Column): ColumnGroup[] => {
  const parents = [];
  let parent = agColumn.getParent() as ColumnGroup | null;
  while (parent) {
    parents.push(parent);
    parent = parent.getParent();
  }
  return parents;
};

export const isLastVisibleColumn = (
  api: GridApi,
  column: Column | undefined | null,
) => {
  const allColumns = api.getAllDisplayedColumns();
  return last(allColumns) === column;
};

export const isFirstVisibleColumn = (
  api: GridApi,
  column: Column | undefined | null,
) => {
  const allColumns = api.getAllDisplayedColumns();
  return first(allColumns) === column;
};

export const isCellRowSpanned = (params: CellClassParams) =>
  params.column.getRowSpan(params.node) > 1;

export const isCellRowSpannedToBottom = (params: CellClassParams) => {
  const rowSpan = params.column.getRowSpan(params.node);
  return (
    rowSpan > 1 &&
    params.rowIndex + rowSpan >= params.api.getDisplayedRowCount()
  );
};

export const getAgClientSideRowModel = <TData>(
  api: GridApi<TData>,
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
): IClientSideRowModel<TData> => get(api, "clientSideRowModel")!;

export const tryGetAgClientSideRowModel = (
  api: GridApi,
): IClientSideRowModel | undefined => get(api, "clientSideRowModel");

export const getFlattenedColDefIds = (
  columnDefs: (ColDef | ColGroupDef)[] | null | undefined,
) =>
  flattenColDefs(columnDefs)
    ?.sort((c1, c2) => (c1.pinned === c2.pinned ? 0 : c1.pinned ? -1 : 1))
    .map((c) => c.colId || c.field);

export const isAgColumn = (
  columnOrGroup: Column | ColumnGroup,
): columnOrGroup is Column =>
  "getColDef" in columnOrGroup && !!columnOrGroup.getColDef;
